{
    "PartitionList_Column_Description": "Descrição",
    "PartitionList_Column_IDInTelSys": "EU IA",
    "PartitionList_Column_Licence": "Licença",
    "PartitionList_Column_Extensions": "Extensões",
    "PartitionList_Column_AcdAgents": "Agentes",
    "PartitionList_Column_AppUsers": "Usuários",
    "PartitionList_Column_SyncType": "Tipo de sincronização",
    "PartitionList_Column_Status": "Status",
    "PartitionList_Filter_Licence": "Licença",
    "PartitionList_CountLink_ExtensionsAria": "Veja os dispositivos nesta partição.",
    "PartitionList_CountLink_AcdAgentsAria": "Veja os agentes ACD nesta partição.",
    "PartitionList_CountLink_AppUsersAria": "Veja os usuários do aplicativo nesta partição.",
    "PartitionList_Add_Disabled_SelectTelephonyServer": "Selecione um servidor de telefonia para adicionar uma partição.",
    "NAME": "PartitionListLanguage"
}